import React from 'react';
import {fetchLocationTableData, setLocation} from "../../redux-store/map";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {getLocations, installationSelect} from "../../redux-store/selectors";

function NavigateDevice({cell}) {

    const installation = useSelector(installationSelect)
    const locations = useSelector(getLocations);

    const dispatch = useDispatch()
    const navigation = useNavigate()

    const handleLocationDetails = locationId => {
        const location = locations.find(location => location.id === locationId);
        if (location === undefined) return;
        dispatch(fetchLocationTableData({installationId: installation.value, locationId: location.id}));
        dispatch(setLocation(location));
        navigation("/location-devices")
    }

    return (
        <span className={"location-alarm-link"}>
            <span className={"fw-bold"} onClick={handleLocationDetails.bind(this, cell.id)}>{cell.value}</span>
        </span>
    );
}

export default NavigateDevice;